"use strict";

module.exports = function (arr) {
  return arr.length > 0 ? arr[arr.length - 1] : null;
};